/* tslint:disable */

/**
 */
export class CardMonthRevenueView {
    route_name?: string;
    station_data?: string;
    barcode?: string;
    ticket_number?: string;
    fullname?: string;
    price?: number;
    count_number_only?: number;
    count_number_all?: number;
    total_revenue?: number;
}
